import { blobticService } from '../../Commun/services/blobticService';

export interface GpsPoint {
    id: string; // TRK_UIDF
    vehicleId: number; // VEH_IDF
    latitude: number;
    longitude: number;
    timestamp: Date;
    speed: number;
    heading: number;
    lastUpdate: Date;
    registrationNumber?: string;
    brand?: string;
    model?: string;
}

interface GpsPointDto {
    TRK_UIDF: string;
    TRK_IDF: number;
    VEH_IDF: number;
    LATITUDE: number;
    LONGITUDE: number;
    TIMESTAMP: string;
    SPEED: number;
    HEADING: number;
    LAST_UPDT: string;
    VEH_REGISTRATION?: string;
    VEH_BRAND?: string;
    VEH_MODEL?: string;
}

const mapDtoToModel = (dto: GpsPointDto): GpsPoint => ({
    id: dto.TRK_UIDF,
    vehicleId: dto.VEH_IDF,
    latitude: dto.LATITUDE,
    longitude: dto.LONGITUDE,
    timestamp: new Date(dto.TIMESTAMP),
    speed: dto.SPEED,
    heading: dto.HEADING,
    lastUpdate: new Date(dto.LAST_UPDT),
    registrationNumber: dto.VEH_REGISTRATION,
    brand: dto.VEH_BRAND,
    model: dto.VEH_MODEL
});

export const gpsApi = {
    getAll: async (): Promise<{ data: GpsPoint[], success: boolean, message?: string }> => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_gps,Select' }
        });

        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    }
};
